 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		42: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		42: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"ChoiceWithRadioButtons~choiceCarouselTemplate~colorWPriceAltStyle~markDownWithCopy~pip~surfaceThickness","1":"choiceCarouselTemplate~colorWPriceAltStyle~edgeStyleTemplate~pip","2":"configurationSummary~countertopDraftingTool~mobileSummary~pip","4":"colorWPriceAltStyle~countertopDraftingTool~pip","6":"choiceCarouselTemplate~choiceStepper","7":"configurationSummary~mobileSummary","8":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","9":"railFlyout","10":"stickyHeader","11":"ChoiceWithRadioButtons","12":"bannerTemplate","13":"choiceCarouselTemplate","14":"choiceStepper","15":"colorWPriceAltStyle","16":"configurationSummary","17":"countertopDraftingTool","19":"customer-image-overlay","20":"defaultTemplate","21":"defaultWithLabelsTemplate","22":"dropDownWithPrice","23":"edgeStyleTemplate","24":"hammerjs","25":"hiddenTemplate","26":"home","27":"infoTile","28":"loading","29":"markDownWithCopy","30":"media-gallery-filmstrip-mobile","31":"media-gallery-overlay","32":"media-gallery-overlay-mobile","33":"minimumAmountModal","34":"mobileSummary","35":"overlay","36":"pcp","37":"pip","38":"productNotAvailable","39":"projectLocation","40":"radioButtonWithCopy","41":"radioButtonWithCopyHideIfOne","43":"simpleChoiceStepper","44":"sqftDecimalInput","45":"stepperTemplate","46":"sticky","47":"storeNotAvailable","48":"surfaceMaterialCarousel","49":"surfaceThickness","51":"warning","52":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"3362282dd6c4a70dd969","1":"78fb839b16c9de8ae621","2":"3c17df58cd0d661a4a17","3":"65639b0c21b5fa181473","4":"0b226cf2425b663e3625","5":"89172686329f7a01c08b","6":"301375c25c4cf706b83d","7":"934e779bd3c09f4910c9","8":"1d91bea22a8db23a0b98","9":"ef3e38ff0249077185c3","10":"500269e85b443b483d20","11":"7183a983f81fc2dce10a","12":"6004edfc668410f9740d","13":"aa1716c9999a842fd6e4","14":"0883b5b80be28dd1e80c","15":"d840f131e534dd995294","16":"433a797a646a3fe59a72","17":"25c09c76ef76cf0f56dc","19":"eb003c578f8921e17810","20":"30ec4e282a23884b5cff","21":"6060b3e5a02248b2fddd","22":"dba81aac22be9da7a683","23":"ed82814b0022781c409b","24":"2a9778374586cde741c1","25":"77e376b4997b7084c065","26":"755304573b207af26fd0","27":"755391004cdef6c3d460","28":"69d6247c708488534745","29":"b71679d9ac3127a3abc8","30":"f9b18e1eac312c24e6a3","31":"89c51261c7f9615ad503","32":"459baf0075ec6f430de5","33":"5d501f2c282f85aab617","34":"4a1025625969684a400f","35":"0562dcd6eb839aef1273","36":"37edc36d93e535d53c67","37":"bbb10ed1c0e313c4cf58","38":"9940b07d4e27efb07365","39":"1da2faeda89b0ca3f9df","40":"b6a36a82ff1b659f147b","41":"8ecda1a3806247d16a7b","43":"fb98184ba9e1069050f9","44":"557aaed7e3fb476299e2","45":"4aab420f0ebf36ff8db3","46":"bda4df2864e0cd5f244c","47":"e5706280156fc65c1743","48":"0b64d9e4bd63c87948ea","49":"a0cda141780f8c0383ad","51":"5d9e55bc8978e75c81f7","52":"bd94467053b7c7950a08","53":"bc99604ce7c09058e903","54":"308d1dc0b5d65dbbbecc","55":"675a935bb87ee219fa91","56":"c1cec54486c078ec57bb","57":"44cf138a90232c2acd63","58":"464ec8468fefff10fe52","59":"a4e914978d786f0db07d","60":"ac8c2069180a53d7930d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"15":1,"17":1,"19":1,"30":1,"31":1,"32":1,"35":1,"36":1,"37":1,"52":1,"53":1,"54":1,"55":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"ChoiceWithRadioButtons~choiceCarouselTemplate~colorWPriceAltStyle~markDownWithCopy~pip~surfaceThickness","1":"choiceCarouselTemplate~colorWPriceAltStyle~edgeStyleTemplate~pip","2":"configurationSummary~countertopDraftingTool~mobileSummary~pip","4":"colorWPriceAltStyle~countertopDraftingTool~pip","6":"choiceCarouselTemplate~choiceStepper","7":"configurationSummary~mobileSummary","8":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","9":"railFlyout","10":"stickyHeader","11":"ChoiceWithRadioButtons","12":"bannerTemplate","13":"choiceCarouselTemplate","14":"choiceStepper","15":"colorWPriceAltStyle","16":"configurationSummary","17":"countertopDraftingTool","19":"customer-image-overlay","20":"defaultTemplate","21":"defaultWithLabelsTemplate","22":"dropDownWithPrice","23":"edgeStyleTemplate","24":"hammerjs","25":"hiddenTemplate","26":"home","27":"infoTile","28":"loading","29":"markDownWithCopy","30":"media-gallery-filmstrip-mobile","31":"media-gallery-overlay","32":"media-gallery-overlay-mobile","33":"minimumAmountModal","34":"mobileSummary","35":"overlay","36":"pcp","37":"pip","38":"productNotAvailable","39":"projectLocation","40":"radioButtonWithCopy","41":"radioButtonWithCopyHideIfOne","43":"simpleChoiceStepper","44":"sqftDecimalInput","45":"stepperTemplate","46":"sticky","47":"storeNotAvailable","48":"surfaceMaterialCarousel","49":"surfaceThickness","51":"warning","52":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"50650a5eb952f31cf1f7","16":"31d6cfe0d16ae931b73c","17":"974bc891ee4124973509","19":"c466036523aec2558c34","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"5c21e06bd098ab014cbc","31":"a1bfef65db1a8261ac5c","32":"6c68edf089a9ec5946b2","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"1d96b60fc53d32d2fc75","36":"1948976e2f39a09bb45c","37":"983542599923f2e5896f","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"b72cc71919e1e1d0c75c","53":"101f84fc53efbf9059b4","54":"a5a0bcf74bbccec32edd","55":"25e852660a3f4c76581e","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/custom-surface-layout-designer/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
